import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Plus } from '@styled-icons/boxicons-regular/Plus';
import { Check } from '@styled-icons/boxicons-regular/Check';
import { DotsHorizontalRounded } from '@styled-icons/boxicons-regular/DotsHorizontalRounded';
import { style } from '../../../api';

const size = 18;

export interface StateProps {
  queue: number[];
}

export interface DispatchProps {
  addTrack: (playlistId: number, trackId: number) => void;
}

export interface OwnProps {
  added: boolean;
  error?: string;
  trackId: number;
  playlistId: number;
}

type Props = StateProps & DispatchProps & OwnProps;

const AddTrack = ({
  added,
  queue,
  error,
  addTrack,
  trackId,
  playlistId,
}: Props) => {
  const [clientAdded, setClientAdded] = useState(false);
  const [clicked, setClicked] = useState(false);
  const pending = queue.some((id) => id === playlistId);
  const onClick = () => {
    addTrack(playlistId, trackId);
    setClicked(true);
  };

  useEffect(() => {
    if (clicked && !pending && !error) setClientAdded(true);
  }, [setClientAdded, clicked, pending, error]);
  /* eslint-disable no-nested-ternary */
  return (
    <PlusBtnBase disabled={added || pending} onClick={onClick}>
      {added || clientAdded ? (
        <Check size={size} color={style.secondary_white_new} />
      ) : pending ? (
        <DotsHorizontalRounded size={size} color={style.secondary_white_new} />
      ) : (
        <Plus size={size} color={style.secondary_white_new} />
      )}
    </PlusBtnBase>
  );
  /* eslint-enable no-nested-ternary */
};

export default AddTrack;

const PlusBtnBase = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px;
  width: 30px;
  height: 30px;
  min-height: 30px;
  background: ${style.green};
  color: ${style.secondary_white_new};
`;
